import { globalState } from '../models';
import { getIsAutoHighlightingEnabled } from '../stateGetters';

export function useIsAutoHighlightingEnabled() {
  return globalState(getIsAutoHighlightingEnabled);
}
